(function() {
  const TGLProduct = window.TGLProduct = window.TGLProduct || {};
  const CLASSNAMES = TGLProduct.CLASSNAMES;
  const SIZE_LABELS = {
    S: 'Small',
    M: 'Medium',
    L: 'Large',
    XL: 'X-Large',
    XS: 'X-Small',
    XXL: 'XX-Large',
    XXS: 'XX-Small'
  };
  const SOLD_OUT_CLASS = 'is-sold-out';

  function findVariant(data, predicate) {
    return (data.variants || []).find(predicate) || null;
  }

  function isVariantAvailable(ctx, variant) {
    if (!variant) return false;
    const inventoryInfo = ctx.data.variantInventory ? ctx.data.variantInventory[variant.id] : null;
    const quantityFromMap = inventoryInfo ? Number(inventoryInfo.inventory_quantity) : NaN;
    const quantityFromVariant = Number(variant.inventory_quantity);
    const hasMappedQuantity = Number.isFinite(quantityFromMap);
    const hasVariantQuantity = Number.isFinite(quantityFromVariant);

    if (hasMappedQuantity) {
      return quantityFromMap > 0;
    }
    if (hasVariantQuantity) {
      return quantityFromVariant > 0;
    }
    if (typeof variant.available === 'boolean') {
      return variant.available;
    }

    return false;
  }

  function findSelectedVariant(ctx) {
    const variants = ctx.data.variants || [];
    const selectedColor = ctx.section.querySelector('[data-color-swatch].selected');
    const selectedSize = ctx.section.querySelector('[data-size-button].selected');
    let variant = null;

    if (selectedColor && selectedSize) {
      const colorValue = selectedColor.dataset.color || selectedColor.title || selectedColor.textContent;
      const sizeValue = selectedSize.dataset.size || selectedSize.textContent;
      variant = findVariant(ctx.data, (v) => v.options && v.options.includes(colorValue) && v.options.includes(sizeValue));
    }

    if (!variant && selectedColor && selectedColor.dataset.variantId) {
      variant = findVariant(ctx.data, (v) => String(v.id) === String(selectedColor.dataset.variantId));
    }

    if (!variant && selectedSize && selectedSize.dataset.variantId) {
      variant = findVariant(ctx.data, (v) => String(v.id) === String(selectedSize.dataset.variantId));
    }

    if (!variant && ctx.variantIdInput && ctx.variantIdInput.value) {
      variant = findVariant(ctx.data, (v) => String(v.id) === String(ctx.variantIdInput.value));
    }

    if (!variant && variants.length) {
      variant = variants[0];
    }

    return variant;
  }

  function toggleSoldOutClass(el, isSoldOut) {
    if (!el) return;
    el.classList.toggle(SOLD_OUT_CLASS, Boolean(isSoldOut));
  }

  function updateColorAvailability(ctx) {
    if (!ctx.colorSwatches || !ctx.colorSwatches.length) return;
    ctx.colorSwatches.forEach((swatch) => {
      const colorValue = swatch.dataset.color || swatch.title || swatch.textContent;
      if (!colorValue) {
        toggleSoldOutClass(swatch, false);
        return;
      }

      const hasAvailableVariant = (ctx.data.variants || []).some((variant) => {
        if (!variant.options || !variant.options.includes(colorValue)) return false;
        return isVariantAvailable(ctx, variant);
      });

      toggleSoldOutClass(swatch, !hasAvailableVariant);
    });
  }

  function updateSizeAvailability(ctx) {
    if (!ctx.sizeButtons || !ctx.sizeButtons.length) return;

    const selectedColorEl = ctx.section.querySelector('[data-color-swatch].selected');
    const selectedColor = selectedColorEl
      ? selectedColorEl.dataset.color || selectedColorEl.title || selectedColorEl.textContent
      : null;

    ctx.sizeButtons.forEach((btn) => {
      let variant = null;
      const sizeValue = btn.dataset.size || btn.textContent;

      if (btn.dataset.variantId) {
        variant = findVariant(ctx.data, (v) => String(v.id) === String(btn.dataset.variantId));
      } else if (selectedColor && sizeValue) {
        variant = findVariant(
          ctx.data,
          (v) => v.options && v.options.includes(selectedColor) && v.options.includes(sizeValue)
        );
      } else if (sizeValue) {
        variant = findVariant(ctx.data, (v) => v.options && v.options.includes(sizeValue));
      }

      toggleSoldOutClass(btn, !isVariantAvailable(ctx, variant));
    });
  }

  function updateOptionAvailability(ctx) {
    updateColorAvailability(ctx);
    updateSizeAvailability(ctx);
  }

  function bindOptions(ctx) {
    ctx.sizeButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        TGLProduct.setActive(ctx.sizeButtons, btn);
        if (typeof TGLProduct.applyVariant === 'function') {
          TGLProduct.applyVariant(ctx, findSelectedVariant(ctx));
        }
        updateOptionAvailability(ctx);
      });
    });

    ctx.colorSwatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        TGLProduct.setActive(ctx.colorSwatches, swatch);
        if (typeof TGLProduct.applyVariant === 'function') {
          TGLProduct.applyVariant(ctx, findSelectedVariant(ctx));
        }
        updateOptionAvailability(ctx);
      });
    });
  }

  function ensureDefaultSelections(ctx) {
    const hasColorSelected = ctx.section.querySelector('[data-color-swatch].selected');
    const hasSizeSelected = ctx.section.querySelector('[data-size-button].selected');

    if (!hasColorSelected && ctx.colorSwatches.length) {
      ctx.colorSwatches[0].classList.add(CLASSNAMES.selected);
    }

    if (!hasSizeSelected && ctx.sizeButtons.length) {
      ctx.sizeButtons[0].classList.add(CLASSNAMES.selected);
    }
  }

  function applySizeLabels(ctx) {
    if (!ctx || !ctx.sizeButtons) return;
    ctx.sizeButtons.forEach((btn) => {
      const raw = btn.dataset.size;
      if (!raw) return;
      const mapped = SIZE_LABELS[raw] || raw;
      if (btn.textContent !== mapped) {
        btn.textContent = mapped;
      }
    });
  }

  TGLProduct.findVariant = findVariant;
  TGLProduct.findSelectedVariant = findSelectedVariant;
  TGLProduct.bindOptions = bindOptions;
  TGLProduct.ensureDefaultSelections = ensureDefaultSelections;
  TGLProduct.applySizeLabels = applySizeLabels;
  TGLProduct.updateOptionAvailability = updateOptionAvailability;
})();
